import {
  BANNER_FETCH,
  BANNER_FETCH_SUCESS,
  BANNER_FETCH_FAIL,

  BANNER_DETAIL_FETCH,
  BANNER_DETAIL_FETCH_SUCESS,
  BANNER_DETAIL_FETCH_FAIL,

  CATEGORY_FETCH,
  CATEGORY_FETCH_SUCESS,
  CATEGORY_FETCH_FAIL,

  PROGRAM_DETAIL_FETCH,
  PROGRAM_DETAIL_FETCH_SUCESS,
  PROGRAM_DETAIL_FETCH_FAIL,

  FAVORITE_SEND_FETCH,
  FAVORITE_SEND_FETCH_SUCESS,
  FAVORITE_SEND_FETCH_FAIL,

  SEARCH_FETCH,
  SEARCH_FETCH_SUCESS,
  SEARCH_FETCH_FAIL,

  ALL_PROGRAM_FETCH,
  ALL_PROGRAM_FETCH_SUCCESS,
  ALL_PROGRAM_FETCH_FAIL,

  PROGRAM_PLAY_FETCH,
  PROGRAM_PLAY_FETCH_SUCCESS,
  PROGRAM_PLAY_FETCH_FAIL,

  LIVE_FETCH,
  LIVE_FETCH_SUCCESS,
  LIVE_FETCH_FAIL,

  OLD_GROUP,

  CURRENT_PLAY_FETCH,
  CURRENT_PLAY_FETCH_SUCCESS,
  CURRENT_PLAY_FETCH_FAIL,


  PROGRAM_DETAIL_PREVIEW_FETCH,
  PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS,
  PROGRAM_DETAIL_PREVIEW_FETCH_FAIL,


  SHARE_FETCH,
  SHARE_FETCH_SUCESS,
  SHARE_FETCH_FAIL,

  CLICK_SHARE_FETCH,
  CLICK_SHARE_FETCH_SUCESS,
  CLICK_SHARE_FETCH_FAIL,

} from '../actions';

const INIT_STATE = {
  bannerloading: false,
  bannerError: '',
  banner: [],
  bannerDetailloading: false,
  bannerDetailError: '',
  bannerDetail: [],
  categoryloading: false,
  categoryError: '',
  category: [],
  programDetailloading: false,
  programDetailError: '',
  programDetail: [],
  programDetailPreviewloading: false,
  programDetailPreviewError: '',
  programDetailPreview: [],
  favoriteSendloading: false,
  favoriteSendError: '',
  favoriteSend: '',
  searchloading: false,
  searchError: '',
  search: [],
  allProgramloading: false,
  allProgramError: '',
  allProgram: [],
  programPlayloading: false,
  programPlayError: '',
  programPlay: [],
  liveListloading: false,
  liveListError: '',
  liveList: [],
  liveUserId: '',
  lineUserSign: '',
  oldGroup: null,
  currentPlayloading: false,
  currentPlayError: '',
  currentPlay: [],
  programShareloading: false,
  programShareError: '',
  programShare: [],

  clickProgramShareloading: false,
  clickProgramShareError: '',
};

export default (state = INIT_STATE, action) => {
  // console.log('action -> ', action.payload)
  switch (action.type) {
    /* banner */
    case BANNER_FETCH:
      return { ...state, bannerloading: true, bannerError: '' };
    case BANNER_FETCH_SUCESS:
      return { ...state, bannerloading: false, banner: action.payload, bannerError: '' };
    case BANNER_FETCH_FAIL:
      return { ...state, bannerloading: false, banner: [], bannerError: action.payload.message };

    /* banner detail */
    case BANNER_DETAIL_FETCH:
      return { ...state, bannerDetailloading: true, bannerDetailError: '' };
    case BANNER_DETAIL_FETCH_SUCESS:
      return { ...state, bannerDetailloading: false, bannerDetail: action.payload, bannerDetailError: '' };
    case BANNER_DETAIL_FETCH_FAIL:
      return { ...state, bannerDetailloading: false, bannerDetail: [], bannerDetailError: action.payload.message };

    /* banner */
    case CATEGORY_FETCH:
      return { ...state, categoryloading: true, categoryError: '' };
    case CATEGORY_FETCH_SUCESS:
      return { ...state, categoryloading: false, category: action.payload, categoryError: '' };
    case CATEGORY_FETCH_FAIL:
      return { ...state, categoryloading: false, category: [], categoryError: action.payload.message };

    /* program detail */
    case PROGRAM_DETAIL_FETCH:
      return { ...state, programDetailloading: true, programDetailError: '' };
    case PROGRAM_DETAIL_FETCH_SUCESS:
      return { ...state, programDetailloading: false, programDetail: action.payload, programDetailError: '' };
    case PROGRAM_DETAIL_FETCH_FAIL:
      return { ...state, programDetailloading: false, programDetail: [], programDetailError: action.payload.message };

    /* favorite send */
    case FAVORITE_SEND_FETCH:
      return { ...state, favoriteSendloading: true, favoriteSendError: '' };
    case FAVORITE_SEND_FETCH_SUCESS:
      return { ...state, favoriteSendloading: false, favoriteSend: action.payload, favoriteSendError: '' };
    case FAVORITE_SEND_FETCH_FAIL:
      return { ...state, favoriteSendloading: false, favoriteSend: '', favoriteSendError: action.payload.message };

    /* search */
    case SEARCH_FETCH:
      return { ...state, searchloading: true, searchError: '' };
    case SEARCH_FETCH_SUCESS:
      return { ...state, searchloading: false, search: action.payload, searchError: '' };
    case SEARCH_FETCH_FAIL:
      return { ...state, searchloading: false, search: [], searchError: action.payload.message };

    /* all Program */
    case ALL_PROGRAM_FETCH:
      return { ...state, allProgramloading: true, allProgramError: '' };
    case ALL_PROGRAM_FETCH_SUCCESS:
      return { ...state, allProgramloading: false, allProgram: action.payload, allProgramError: '' };
    case ALL_PROGRAM_FETCH_FAIL:
      return { ...state, allProgramloading: false, allProgram: [], allProgramError: action.payload.message };

    /* Program play */
    case PROGRAM_PLAY_FETCH:
      return { ...state, programPlayloading: true, programPlayError: '' };
    case PROGRAM_PLAY_FETCH_SUCCESS:
      return { ...state, programPlayloading: false, programPlay: action.payload.programPlay, programPlayError: '' };
    case PROGRAM_PLAY_FETCH_FAIL:
      return { ...state, programPlayloading: false, programPlay: [], programPlayError: action.payload.message };

    /* live */
    case LIVE_FETCH:
      return { ...state, liveListloading: true, liveListError: '' };
    case LIVE_FETCH_SUCCESS:
      return {
        ...state, liveListloading: false,
        liveList: action.payload.liveList,
        liveUserId: action.payload.liveUserId,
        lineUserSign: action.payload.liveUserSign,
        liveListError: ''
      };
    case LIVE_FETCH_FAIL:
      return { ...state, liveListloading: false, liveList: [], liveListError: action.payload.message };
    case OLD_GROUP:
      return { ...state, oldGroup: action.payload };

    /* current play */
    case CURRENT_PLAY_FETCH:
      return { ...state, currentPlayloading: true, currentPlayError: '' };
    case CURRENT_PLAY_FETCH_SUCCESS:
      return { ...state, currentPlayloading: false, currentPlay: action.payload.currentPlay, currentPlayError: '' };
    case CURRENT_PLAY_FETCH_FAIL:
      return { ...state, currentPlayloading: false, currentPlay: [], currentPlayError: action.payload.message };


    /* program detail */
    case PROGRAM_DETAIL_PREVIEW_FETCH:
      return { ...state, programDetailPreviewloading: true, programDetailPreviewError: '' };
    case PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS:
      return { ...state, programDetailPreviewloading: false, programDetailPreview: action.payload, programDetailPreviewError: '' };
    case PROGRAM_DETAIL_PREVIEW_FETCH_FAIL:
      return { ...state, programDetailPreviewloading: false, programDetailPreview: [], programDetailPreviewError: action.payload.message };


    /* program detail */
    case SHARE_FETCH:
      return { ...state, programShareloading: true, programShareError: '' };
    case SHARE_FETCH_SUCESS:
      return { ...state, programShareloading: false, programShare: action.payload, programShareError: '' };
    case SHARE_FETCH_FAIL:
      return { ...state, programShareloading: false, programShare: [], programShareError: action.payload.message };


    case CLICK_SHARE_FETCH:
      return { ...state, clickProgramShareloading: true, clickProgramShareError: '' };
    case CLICK_SHARE_FETCH_SUCESS:
      return { ...state, clickProgramShareloading: false, programShare: action.payload, clickProgramShareError: '' };
    case CLICK_SHARE_FETCH_FAIL:
      return { ...state, clickProgramShareloading: false, programShare: [], clickProgramShareError: action.payload.message };

    default: return { ...state };
  }
}
